/**
 * Где искать поставщика — одной строкой.
 *
 * На выставке это стенд и зал, в здании — этаж и офис. Раньше каждый экран
 * собирал подпись сам из booth и hall, и здание в эти подписи не попадало бы
 * никогда. Здесь одно место, которое знает оба случая.
 */
export function whereIs(s: { booth?: string; hall?: string; floor?: string; office?: string }): string {
  const parts: string[] = [];
  if (s.floor) parts.push(`${s.floor} эт.`);
  if (s.office) parts.push(`оф. ${s.office}`);
  if (!parts.length) {
    if (s.booth) parts.push(`стенд ${s.booth}`);
    if (s.hall) parts.push(`зал ${s.hall}`);
  }
  return parts.join(' · ');
}
